/**
 * Open Status html ajax
 * ======================================
 * - handled with ajax/index.php
 */

 const ELEMENTS = '.tabs-bookmarks__hours'

 class OpenStatus {
   constructor() {
     this.elements = document.querySelectorAll(ELEMENTS)
     this.ajaxUrl = '/app/themes/ipress/ajax/index.php'

     if(!this.elements) {
      return
     }

     this.ajaxHandler()
   }

   ajaxHandler = () => {
     const xhr = new XMLHttpRequest()
     xhr.open('POST', this.ajaxUrl, true)
     xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
     xhr.send('action=openStatus&lang='+lang)

     xhr.onreadystatechange = () => {
       if (xhr.readyState === 4) {
         // ok
         if (xhr.status === 200) {
           const response = JSON.parse(xhr.response)

           response.venues.forEach(val => {
              const targetEl = document.querySelector(ELEMENTS+'[data-id="'+val.id+'"]')

              if(!targetEl) {
                return
              }

              if(val.status){
                targetEl.classList.add('is-open')
              } else {
                targetEl.classList.add('is-closed')
              }
           });
         }
         // error
         else {
           console.log('ajaxForm error!', xhr)
         }
       }
     }
   }
 }

 new OpenStatus()
